import styled from "styled-components";

export const Column = styled.div``;

export const Header = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  align-items: center;
  margin-top: 16px;

  .columnTitle {
    display: flex;
    align-items: center;
    height: 16px;
    width: 100%;
    font-size: 12px;
    font-weight: 600;
    line-height: 16px;
    color: ${({ theme }) => theme.colors.surface.onSurface};
  }

  .columnSigla {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 16px;
    min-width: 75px;
    width: 91px;
    padding-left: 16px;
    font-size: 12px;
    font-weight: 600;
    line-height: 16px;
    color: ${({ theme }) => theme.colors.surface.onSurface};
  }

  .columnEtapa {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 16px;
    min-width: 75px;
    width: 91px;
    padding-left: 16px;
    font-size: 12px;
    font-weight: 600;
    line-height: 16px;
    color: ${({ theme }) => theme.colors.surface.onSurface};
  }
`;

export const Body = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;

  .row {
    width: 100%;
    height: 16px;
    display: flex;
    flex-direction: row;
    align-items: center;
    margin-top: 12px;

    .columnTitle {
      width: 100%;
      font-size: 12px;
      font-weight: 600;
      line-height: 16px;
      color: ${({ theme }) => theme.colors.surface.onSurfaceVariant};
    }  

    .columnSigla {
      display: flex;
      justify-content: center;
      width: 91px;
      padding-left: 16px;
      font-weight: 600;
      line-height: 16px;
      color: ${({ theme }) => theme.colors.surface.onSurfaceVariant};
    }  

    .columnEtapa {
      display: flex;
      justify-content: center;
      width: 91px;
      padding-left: 16px;
      font-size: 12px;
      font-weight: 600;
      line-height: 16px;
      color: ${({ theme }) => theme.colors.surface.onSurfaceVariant};
    }  
  }
`;
